import { handleActions, combineActions } from "redux-actions";

import {
	getPresetsAsyncAction,
	getTournamentsAsyncAction,
	createPresetItemAsyncAction,
	deletePresetItemAsyncAction,
	getTournamentAsyncAction,
	updateTournamentStatusAsyncAction,
	getTournamentJoinedAsyncAction,
	deleteTournamentAsyncAction,
	getResultsAsyncAction,
	updateTournamentResultsAsyncAction,
	joinTournamentAsyncAction,
	withdrawTournamentAsyncAction,
	resetAction,
} from "./tournamentActions";

const defaultAjaxState = {
	response: null,
	error: null,
	loading: false,
};

const initialState = {
	presets: [],
	preset: {},

	result_list: defaultAjaxState,
	update_results: defaultAjaxState,
	join_tournament: defaultAjaxState,
	withdraw_tournament: defaultAjaxState,

	list: {
		items: [],
		meta: {
			currentPage: 0,
			totalPages: 0,
		},
	},

	joined: {
		items: [],
		meta: {
			currentPage: 0,
			totalItems: 0,
			totalPages: 0,
		},
	},

	detail: {
		shop: {},
		series: {},
		format: {},
		presets: [],
		prizes: [],
		tournamentId: "",
		status: "",
	},

	fetch: {
		loading: false,
		error: "",
	},

	action: {
		loading: false,
		success: false,
		error: "",
	},
};

export const tournamentReducer = handleActions(
	new Map([
		[
			getPresetsAsyncAction.success,
			(state, { payload }) => ({
				...state,
				presets: payload,
			}),
		],
		[
			[
				combineActions(
					createPresetItemAsyncAction.request,
					deletePresetItemAsyncAction.request,
					updateTournamentStatusAsyncAction.request,
					deleteTournamentAsyncAction.request
				),
			],
			(state) => ({
				...state,
				action: {
					...initialState.action,
					loading: true,
				},
			}),
		],
		[
			combineActions(
				createPresetItemAsyncAction.success,
				deletePresetItemAsyncAction.success,
				deleteTournamentAsyncAction.success,
				updateTournamentStatusAsyncAction.success
			),
			(state, { payload }) => ({
				...state,
				action: {
					...initialState.action,
					success: payload,
				},
			}),
		],
		[
			getTournamentsAsyncAction.success,
			(state, { payload }) => ({
				...state,
				list: payload,
			}),
		],
		[
			getTournamentAsyncAction.success,
			(state, { payload }) => ({
				...state,
				detail: payload,
			}),
		],
		[
			getTournamentJoinedAsyncAction.success,
			(state, { payload }) => ({
				...state,
				joined: payload,
			}),
		],

		// get results
		[
			getResultsAsyncAction.request,
			(state, { payload }) => ({
				...state,
				result_list: {
					...initialState.result_list,
					loading: true,
				},
			}),
		],
		[
			getResultsAsyncAction.success,
			(state, { payload }) => ({
				...state,
				result_list: {
					...initialState.result_list,
					response: payload,
				},
			}),
		],
		[
			getResultsAsyncAction.failure,
			(state, { payload }) => ({
				...state,
				result_list: {
					...initialState.result_list,
					error: payload,
				},
			}),
		],

		// put join tournament
		[
			joinTournamentAsyncAction.request,
			(state, { payload }) => ({
				...state,
				join_tournament: {
					...initialState.join_tournament,
					loading: true,
				},
			}),
		],
		[
			joinTournamentAsyncAction.success,
			(state, { payload }) => ({
				...state,
				join_tournament: {
					...initialState.join_tournament,
					response: payload,
				},
			}),
		],
		[
			joinTournamentAsyncAction.failure,
			(state, { payload }) => ({
				...state,
				join_tournament: {
					...initialState.join_tournament,
					error: payload,
				},
			}),
		],

		// put withdraw tournament
		[
			withdrawTournamentAsyncAction.request,
			(state, { payload }) => ({
				...state,
				withdraw_tournament: {
					...initialState.withdraw_tournament,
					loading: true,
				},
			}),
		],
		[
			withdrawTournamentAsyncAction.success,
			(state, { payload }) => ({
				...state,
				withdraw_tournament: {
					...initialState.withdraw_tournament,
					response: payload,
				},
			}),
		],
		[
			withdrawTournamentAsyncAction.failure,
			(state, { payload }) => ({
				...state,
				withdraw_tournament: {
					...initialState.withdraw_tournament,
					error: payload,
				},
			}),
		],

		// put results
		[
			updateTournamentResultsAsyncAction.request,
			(state, { payload }) => ({
				...state,
				update_results: {
					...initialState.update_results,
					loading: true,
				},
			}),
		],
		[
			updateTournamentResultsAsyncAction.success,
			(state, { payload }) => ({
				...state,
				update_results: {
					...initialState.update_results,
					response: payload,
				},
			}),
		],
		[
			updateTournamentResultsAsyncAction.failure,
			(state, { payload }) => ({
				...state,
				update_results: {
					...initialState.update_results,
					error: payload,
				},
			}),
		],

		// reset
		[
			resetAction,
			(state, { payload }) => ({
				...state,
				[payload]: initialState[payload],
			}),
		],
	]),
	initialState
);
